var fn = function( obj ){
var __t,__p='';
__p+='\nvarying vec2 vTexCoord0;\nuniform sampler2D tTex;\n\nvoid main(void){\n  gl_FragColor = texture2D( tTex, vTexCoord0 );//+vec4(1.0, vec3(0.0));\n}\n';
return __p;
};
fn.toString=fn;
module.exports = fn;